export let MessageTypes;
(function (MessageTypes) {
  MessageTypes["User"] = "UserMessage";
  MessageTypes["Swift"] = "SwiftCard";
  MessageTypes["System"] = "SystemMessage";
  MessageTypes["Welcome"] = "Welcome";
  MessageTypes["Translate"] = "Translate";
  MessageTypes["Image"] = "LwcImage";
  MessageTypes["File"] = "LwcFile";
  MessageTypes["AdaptiveCard"] = "card";
  MessageTypes["Thread"] = "Thread";
})(MessageTypes || (MessageTypes = {}));